import { render, staticRenderFns } from "./arrangeEdit.vue?vue&type=template&id=4619a562&scoped=true&"
import script from "./arrangeEdit.vue?vue&type=script&lang=js&"
export * from "./arrangeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4619a562",
  null
  
)

export default component.exports